import { createContext, useContext, useState } from 'react';

type Props = {
  children: React.ReactNode;
};

type Level1SectionList = {
  under_hood: boolean;
  drive_cycles: boolean;
  exterior: boolean;
  interior_questions: boolean;
};

export type SectionKey = keyof Level1SectionList;

type ListExpandContextBody = {
  toggle: (section: SectionKey) => void;
  open: (section: SectionKey) => void;
  list: Level1SectionList;
};

const defaultValue: ListExpandContextBody = {
  toggle: () => {},
  open: () => {},
  list: {
    under_hood: false,
    drive_cycles: false,
    exterior: false,
    interior_questions: false
  }
};

const ListExpandContext = createContext(defaultValue);

export const ListExpandContextProvider = ({ children }: Props) => {
  const [level1List, setLevel1List] = useState({
    under_hood: false,
    drive_cycles: false,
    exterior: false,
    interior_questions: false
  });

  const toggle = (sectionId: keyof typeof level1List) => {
    return setLevel1List(curr => ({
      ...curr,
      [sectionId]: !curr[sectionId]
    }));
  };

  const open = (sectionId: keyof typeof level1List) => {
    return setLevel1List(curr => ({
      ...curr,
      [sectionId]: true
    }));
  };

  return (
    <ListExpandContext.Provider
      value={{
        toggle,
        open,
        list: level1List,
      }}
    >
      {children}
    </ListExpandContext.Provider>
  );
};

export const useListExpandActions = () => {
  const { open, toggle } = useContext(ListExpandContext);
  return { open, toggle };
};

export const useIsListExpanded = (sectionId: SectionKey) => {
  const { list } = useContext(ListExpandContext);
  return list[sectionId];
};
